import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import SEO from '@/components/base/SEO';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import LatestMoviesSection from './components/LatestMoviesSection';
import HotMoviesSection from './components/HotMoviesSection';
import FAQSection from './components/FAQSection';

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [location.pathname]);

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '快看影视',
    url: 'https://kuikanys.com',
    description: '高清免费电影在线观看，电影大全不缓冲，最新电影免费秒播，流畅高清不卡顿免费看。',
    foundingDate: '2023',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      email: 'service@kuikanys.com',
      availableLanguage: ['Chinese'],
    },
    sameAs: [
      'https://weibo.com/kuikanys',
    ],
  };

  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '快看影视 - 高清免费电影在线观看',
    description: '快看影视提供高清电影免费在线观看，电影大全、最新电影不缓冲流畅秒播，免费电影高清在线看，播放稳定不卡顿，满足你的观影需求。',
    url: 'https://kuikanys.com',
    isPartOf: {
      '@type': 'WebSite',
      name: '快看影视',
      url: 'https://kuikanys.com',
    },
  };

  const webSiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '快看影视',
    url: 'https://kuikanys.com',
    description: '高清免费电影在线观看，电影大全不缓冲，最新电影免费秒播，流畅高清不卡顿免费看。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://kuikanys.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  return (
    <>
      <SEO
        title="快看影视 - 高清免费电影在线观看，电影大全不缓冲，最新电影免费秒播"
        description="快看影视提供高清电影免费在线观看，电影大全、最新电影不缓冲流畅秒播。免费电影高清在线看，播放稳定不卡顿，涵盖动作片、喜剧片、科幻片、爱情片、恐怖片、纪录片、动画片、犯罪片等各类电影。"
        keywords="高清电影,免费电影,电影大全,最新电影,电影在线观看,电影不缓冲,流畅播放,秒播,快看影视"
        canonicalUrl="https://kuikanys.com"
      />
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(webSiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(webPageSchema)}</script>
      <div className="min-h-screen bg-background-50">
        <Navbar transparent />
        <main>
          <HeroSection />
          <CategorySection />
          <LatestMoviesSection />
          <HotMoviesSection />
          <FAQSection />
        </main>
        <Footer />
        <ScrollToTop />
      </div>
    </>
  );
}